import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Quiz from './pages/Quiz';
import DeviceCheck from './components/DeviceCheck';

const App: React.FC = () => {
  return (
    <DeviceCheck>
      <Router basename="/">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/quiz" element={<Quiz />} />
        </Routes>
      </Router>
    </DeviceCheck>
  );
};

export default App;
